module.exports = __webpack_public_path__ + "static/media/Round1.ea508522.jpeg";